import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import NormalInput from "component/common/NormalInput/index";
import ErrorMessage from "component/common/ErrroMessage/index";
import Select from "component/common/Select/index";
import SaveCancelBtn from "component/common/SaveCancelBtn/index";
import { useHistory } from "react-router-dom";
import { addStaff, getRoleDropDown } from "service/StaffsAndRoles";
import { Toast } from "utils/toast";
import usePopup from "hooks/usePopUp";
import arrow from "assets/images/arrow.svg";

import styles from "./AddStaff.module.scss";

const AddStaff = () => {
  const {
    handleSubmit,
    setValue,
    clearErrors,
    register,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const history = useHistory();

  const [roleOptions, setRoleOptions] = useState([
    "Admin",
    "Accountant",
    "Social Media Handler",
    "Super Admin",
  ]);

  let [assignRole, setAssignRole] = useState("");

  let [roles, setRoles] = useState();

  const { successPopUp, togglePopUp, setMsg } = usePopup();

  useEffect(() => {
    getRole();
    setMsg("Staff has been added successfully");
  }, []);

  const getRole = async () => {
    try {
      let response = await getRoleDropDown();
      if (response.status == 200) {
        let role = [];
        response.data.data.result.map((list, index) => {
          role.push(list.name);
        });
        setRoleOptions(role);
        setRoles(response.data.data.result);
      }
    } catch (error) {
      Toast({ type: "error", message: error?.data?.message });
    }
  };

  const onSubmit = async (data) => {
    let roleId = roles.find((list, index) => {
      return list.name == data.assignRole;
    });
    let body = { ...data, role: roleId._id };
    try {
      let response = await addStaff(body);
      if (response.status == 200) {
        reset({
          staffName: "",
          phoneNumber: "",
          emailId: "",
        });
        setAssignRole("");
        togglePopUp();
        setTimeout(() => {
          history.goBack();
        }, 2000);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const handleSelect = (event) => {
    setValue(event.name, event.value);
    setAssignRole(event.value);
    clearErrors(event.name);
  };

  return (
    <>
      <div className={styles.addStaff_title}>
        <img
          src={arrow}
          className="back-arrow"
          onClick={() => history.goBack()}
        />
        <b>Add Staff</b>
      </div>
      <div className={styles.addStaff_box}>
        <div className="row">
          <div className="col-md-4">
            <div className={styles.addStaff_field}>
              <NormalInput
                register={register("staffName", {
                  required: true,
                  pattern: /^[A-Za-z ]+$/,
                  minLength: 3,
                })}
                label="Staff Name"
                error={errors.staffName}
              />
              <ErrorMessage
                error={errors.staffName}
                message={{
                  required: "Please enter staff name",
                  minLength: "Staff name contain atleast 3 characters",
                  pattern: "Staff name contain string only",
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className={styles.addStaff_field}>
              <Controller
                name="assignRole"
                control={control}
                rules={{ required: true }}
                render={() => (
                  <Select
                    placeholder="Enter Here"
                    label="Assign Role"
                    name="assignRole"
                    onChange={handleSelect}
                    options={roleOptions}
                    value={assignRole}
                    error={errors.assignRole}
                  />
                )}
              />
              <ErrorMessage
                error={errors.assignRole}
                message={{ required: "Please select any one role" }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className={styles.addStaff_field}>
              <NormalInput
                register={register("phoneNumber", {
                  required: true,
                  pattern: /^[0-9]{10}$/,
                })}
                type="number"
                label="Phone Number"
                error={errors.phoneNumber}
              />
              <ErrorMessage
                error={errors.phoneNumber}
                message={{
                  required: "Please enter phone number",
                  pattern: "Phone number contain 10 numbers only",
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className={styles.addStaff_field}>
              <NormalInput
                register={register("emailId", {
                  required: true,
                  pattern:
                    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                })}
                label="Email Address"
                error={errors.emailId}
              />
              <ErrorMessage
                error={errors.emailId}
                message={{
                  required: "Please enter email",
                  pattern: "Invalid email",
                }}
              />
            </div>
          </div>
          <div className="col-md-8">
            <SaveCancelBtn
              onSave={handleSubmit(onSubmit)}
              onCancel={() => history.goBack()}
              position="center"
            />
          </div>
        </div>
      </div>
      {successPopUp()}
    </>
  );
};

export default AddStaff;
